import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { GetStagedShipmentResponse } from '../../core/api/lab.types';

export const getStagedShipmentThunk = createAsyncThunk(
  'shipment/getStagedShipment',
  async (_, { rejectWithValue }: any) => {
    const response: GetStagedShipmentResponse = await labApi.getStagedShipment();

    if (response.data?.getStagedShipment) {
      return response.data.getStagedShipment;
    }

    return rejectWithValue(response.errors);
  },
);
